import React, { useState } from "react";
import { Button, Popover } from "@material-ui/core";

export const CysButtonPopover = ({ buttonMsg, popoverText }) => {
  const [anchorEl, setAnchorEl] = useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);

  return (
    <>
      <Button variant="outlined" color="secondary" size="small" onClick={handleClick}>
        {buttonMsg}
      </Button>
      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
      >
        <div>{popoverText}</div>
      </Popover>
    </>
  );
};
